import React from "react";
import cierreWeb from "../assets/Cierre/cierre_web_1920x1080.jpg";
import cierreMobile from "../assets/Cierre/cierre_mobile_1080x1920.jpg";
import { MOBILE_MAX } from "./sliderData.js";

// Pantalla de cierre: el evento ya terminó y el sitio muestra sólo esta placa
// (1920x1080 en web, 1080x1920 en mobile), entera y centrada sobre negro.
export default function Cierre() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1,
        backgroundColor: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <picture>
        <source media={`(max-width: ${MOBILE_MAX}px)`} srcSet={cierreMobile} />
        <img
          src={cierreWeb}
          alt="TERA - Gracias por haber sido parte"
          style={{
            display: "block",
            maxWidth: "100vw",
            maxHeight: "100dvh",
            width: "auto",
            height: "auto",
            objectFit: "contain",
          }}
        />
      </picture>
    </div>
  );
}
